<template>
  <div class="promotion-code px-10">
    <div v-if="promotionCode" class="relative bg-gray-100 px-4 py-3 rounded flex items-center">
      <div class="w-6 h-6 rounded-full bg-green-300 flex items-center justify-center">
        <OSvg svg="checkmark" class="fill-gray-400 checkmark-icon text-white h-4" />
      </div>
      <div class="ml-2 flex-1">
        <p class="text-md font-bold antialiased" v-text="$t('SignUp.StepFive.PromoCodeAdded')" />
        <span class="ota-small-light uppercase" v-text="promotionCode" />
      </div>
      <div
        class="bg-black rounded-full delete-button flex items-center justify-center cursor-pointer hover:bg-gray-500"
        @click="$emit('delete')"
      >
        <OSvg
          svg="cross"
          class="fill-white h-3 w-3"
        />
      </div>
    </div>
    <div v-else class="border-t border-b border-1 px-8 py-3 border-r-0 border-l-0 border-gray-200 text-gray-600">
      <button
        class="flex items-center w-full text-left rounded p-2 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-turquoise-300 focus:ring-offset-0 transition-colors duration-150"
        type="button"
        tabindex="0"
        @click="$emit('open')"
      >
        <OSvg svg="add" class="fill-gray-400 text-turquoise-300 h-5 w-5 mr-3" />
        <p class="ota-p14" v-text="$t('SignUp.StepFive.AddPromoCodeTitle')" />
      </button>
    </div>
  </div>
</template>

<script>
const OSvg = () => import('@/components/OSvg')

export default {
  name: 'PromoCode',
  components: {
    OSvg
  },
  props: {
    promotionCode: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss" scoped>
.delete-button {
  width: 2.6rem;
  height: 2.6rem;
  position: absolute;
  top: -1.3rem;
  right: -1.3rem
}
</style>
